// Item key resolution utility

/**
 * Resolve a unique key for an item from locker
 * @param {Object} item - Item object
 * @param {number} fallbackIndex - Fallback index if no key can be resolved
 * @returns {string} Unique key for the item
 */
export function resolveItemKey(item, fallbackIndex) {
  if (!item || typeof item !== 'object') {
    return `idx:${fallbackIndex}`;
  }
  if (typeof item.id === 'string' && item.id.trim().length > 0) {
    return item.id.trim();
  }
  if (
    item.prize &&
    typeof item.prize === 'object' &&
    typeof item.prize.id === 'string' &&
    item.prize.id.trim().length > 0
  ) {
    return item.prize.id.trim();
  }
  if (typeof item.timestamp === 'string' && item.timestamp.trim().length > 0) {
    return item.timestamp.trim();
  }
  return `idx:${fallbackIndex}`;
}

